/* CUSTOM[aloe-shop] P3: Timeline Fade-in beim Scroll
   Reines IntersectionObserver, kein externes JS. */
(function () {
  'use strict';

  function init() {
    var phases = document.querySelectorAll('.aloe-timeline__phase');
    if (!phases.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          // gestaffeltes Fade-in fuer schoenere Anmutung
          var phase = entry.target;
          var idx = Array.prototype.indexOf.call(phase.parentNode.children, phase);
          setTimeout(function () {
            phase.classList.add('is-visible');
          }, idx * 80);
          observer.unobserve(phase);
        }
      });
    }, { threshold: 0.15 });

    phases.forEach(function (p) { observer.observe(p); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor re-render
  document.addEventListener('shopify:section:load', init);
})();
